import { render, staticRenderFns } from "./CustomerOrderDetail.vue?vue&type=template&id=3b9c47dc"
import script from "./CustomerOrderDetail.vue?vue&type=script&lang=js"
export * from "./CustomerOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports